import { BaseRepository } from './base-repository';
import type { DefectCatalogResponse } from '@core/types/catalog';
import type { ComponentDefectCatalogResponse } from '@core/types/catalog';

export class CatalogAPI extends BaseRepository {
  private readonly baseEndpoint = '/api/method';

  /**
   * GET /api/method/defect-catalog
   * Fetches defect catalog for an item (machine-level), including components list.
   * @param itemCode - Required item code
   * @param serialNo - Optional serial number
   */
  async getDefectCatalog(itemCode: string, serialNo?: string): Promise<DefectCatalogResponse> {
    const params: Record<string, string> = { item_code: itemCode };
    if (serialNo) {
      params.serial_no = serialNo;
    }
    return this.getAll<DefectCatalogResponse>(
      `${this.baseEndpoint}/defect-catalog`,
      params
    );
  }

  /**
   * GET /api/method/component-defect-catalog
   * Fetches defect catalog for a specific component (no components list in response).
   * @param itemCode - Required component item code
   */
  async getComponentDefectCatalog(itemCode: string): Promise<ComponentDefectCatalogResponse> {
    return this.getAll<ComponentDefectCatalogResponse>(
      `${this.baseEndpoint}/component-defect-catalog`,
      { item_code: itemCode }
    );
  }
}
